import moment from 'moment';

export const startOfDay = (d) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};

export const startOfToday = () => startOfDay(new Date());

export const parseDate = (value) => {
  if (!value) return null;
  const s = String(value).trim();

  // dd/mm/yyyy
  let m = s.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  if (m) {
    const dd = Number(m[1]);
    const mm = Number(m[2]);
    const yy = Number(m[3]);
    const d = new Date(yy, mm - 1, dd);
    return Number.isNaN(d.getTime()) ? null : startOfDay(d);
  }

  // yyyy-mm-dd (ou datetime começando com yyyy-mm-dd)
  m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    const yy = Number(m[1]);
    const mm = Number(m[2]);
    const dd = Number(m[3]);
    const d = new Date(yy, mm - 1, dd);
    return Number.isNaN(d.getTime()) ? null : startOfDay(d);
  }

  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : startOfDay(d);
};

export const fmtDateBr = (value) => {
  const d = parseDate(value);
  return d ? moment(d).format('DD/MM/YYYY') : '-';
};

export const num = (v) => (v == null ? 0 : Number(v) || 0);

export const diffDays = (a, b) => {
  // a-b in days (inteiro), comparando em startOfDay
  const da = startOfDay(a).getTime();
  const db = startOfDay(b).getTime();
  return Math.round((da - db) / 86400000);
};

export const isLiberado = (rec) => Number(rec?.rec_aut) === 1;
export const isFaturado = (rec) => Number(rec?.rec_fat) === 1;
export const isRecebido = (rec) => Number(rec?.rec_risco) === 0;

/** Liberado para emitir NF: autorizado, ainda não faturado e com data prevista. */
export const isLiberadoParaEmissao = (rec) =>
  isLiberado(rec) && !isFaturado(rec) && Boolean(parseDate(rec?.rec_dtNfPrev));

export const monthRefDefault = () => moment().format('YYYY-MM');

export const monthRefToRange = (mesRef) => {
  // mesRef: YYYY-MM
  const m = moment(mesRef, 'YYYY-MM', true);
  const start = m.isValid() ? m.startOf('month').toDate() : moment().startOf('month').toDate();
  const endExclusive = m.isValid() ? m.add(1, 'month').startOf('month').toDate() : moment().add(1, 'month').startOf('month').toDate();
  return { start: startOfDay(start), endExclusive: startOfDay(endExclusive) };
};

export const inRange = (d, start, endExclusive) => {
  if (!d) return false;
  const x = startOfDay(d).getTime();
  return x >= startOfDay(start).getTime() && x < startOfDay(endExclusive).getTime();
};

